(() => {
  'use strict';
  if (!document.getElementById('main-cart-items')) return;
  let revision = 0;
  let updating = false;
  const sections = () => ['main-cart-items', 'main-cart-footer'].map(id => ({id, section: document.getElementById(id)?.dataset.id})).filter(entry => entry.section);
  function showError(message) {
    const target = document.getElementById('cart-errors');
    if (target) target.textContent = message || window.cartStrings.error;
  }
  async function refresh() {
    const requestRevision = ++revision;
    const entries = sections();
    const url = new URL(window.routes.cart_url, location.origin);
    url.searchParams.set('sections', entries.map(entry => entry.section).join(','));
    try {
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error(window.cartStrings.error);
      const html = await response.json();
      if (requestRevision !== revision) return;
      const replacements = entries.map(entry => {
        const source = new DOMParser().parseFromString(html[entry.section] || '', 'text/html').getElementById(entry.id);
        if (!source) throw new Error(window.cartStrings.error);
        return {id:entry.id, source};
      });
      for (const {id, source} of replacements) document.getElementById(id).replaceChildren(...source.childNodes);
      document.body.classList.toggle('gcp-empty', !document.querySelector('#main-cart-items .cart-item'));
    } catch (error) { showError(error.message); }
  }
  async function update(line, quantity) {
    if (updating || window.GarrnishCart.busy) return;
    const row = document.getElementById(`CartItem-${line}`);
    if (!row) return;
    const key = row.dataset.lineKey;
    updating = true;
    document.getElementById('main-cart-items').setAttribute('aria-busy', 'true');
    try {
      const result = await window.GarrnishCart.changeQuantity(key, Number(quantity));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && result.sections && drawer.getSectionsToRender().every(entry => result.sections[entry.id])) drawer.renderContents(result, false);
      await refresh();
      const target = document.getElementById(`Quantity-${line}`) || document.querySelector('.gcp-header h1, .gc-cart-back');
      if (target && !drawer?.isOpen) { target.setAttribute('tabindex', '0'); target.focus({preventScroll:true}); }
    } catch (error) { showError(error.message); }
    finally { updating = false; document.getElementById('main-cart-items')?.removeAttribute('aria-busy'); }
  }
  window.GarrnishCartPage = {refresh, update};
  document.addEventListener('garrnish:cart-updated', refresh);
  document.addEventListener('garrnish:cart-busy', event => {
    for (const element of document.querySelectorAll('.gcp-buttons, .gcp-express')) element.inert = event.detail;
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.body.classList.toggle('gcp-empty', !document.querySelector('#main-cart-items .cart-item'));
})();
